import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { ThemeContext } from "../../../../lib/theming/ThemeContext";
import { jsStyles } from "../MobilePopupFooter.styles";
export var MobilePopupFooter = /*#__PURE__*/function (_React$Component) {
  function MobilePopupFooter() {
    return _React$Component.apply(this, arguments) || this;
  }
  _inheritsLoose(MobilePopupFooter, _React$Component);
  var _proto = MobilePopupFooter.prototype;
  _proto.render = function render() {
    var _this = this;
    return /*#__PURE__*/(
      React.createElement(ThemeContext.Consumer, null, function (theme) {
        _this.theme = theme;
        return _this.renderMain();
      })
    );
  };
  _proto.renderMain = function renderMain() {
    var children = this.props.children;
    if (!children || ! /*#__PURE__*/React.isValidElement(children)) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: jsStyles.root(this.theme)
    }, children);
  };
  return MobilePopupFooter;
}(React.Component);
MobilePopupFooter.__KONTUR_REACT_UI__ = 'MobileMenuFooter';